module.exports = __webpack_public_path__ + "img/tripteev-sem-slogan.c0ca0d4a.svg";